// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="body2" align="justify" mb={4}>
            Nuestros programas de Formación y Concienciación están diseñados para equipar a tu equipo con el conocimiento y las habilidades necesarias para defenderse contra las amenazas cibernéticas. Ofrecemos cursos completos, talleres y un programa de posgrado en IA y Ciberseguridad.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Ofertas Clave
          </MKTypography>
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="school"
                title="Cursos"
                description="Ofrecemos una variedad de cursos sobre ciberseguridad y concienciación, adaptados a diferentes niveles de habilidad y roles dentro de tu organización."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="work"
                title="Talleres"
                description="Nuestros talleres prácticos se centran en habilidades prácticas y escenarios del mundo real para ayudar a tu equipo a mantenerse a la vanguardia de las amenazas cibernéticas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={4} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="school"
                title="Programa de Posgrado"
                description="Ofrecemos un programa de posgrado en IA y Ciberseguridad, proporcionando conocimientos avanzados y habilidades para profesionales que buscan especializarse en estos campos."
              />
            </Grid>
          </Grid>
          <MKTypography variant="body2" align="justify" mt={4}>
            Los programas efectivos de formación y concienciación son esenciales para construir una cultura sólida de ciberseguridad dentro de tu organización. Al invertir en estos programas, puedes mejorar la capacidad de tu equipo para reconocer y responder a las amenazas cibernéticas, protegiendo en última instancia los activos digitales y la reputación de tu organización.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;